export function loadFocusOutlineEvents() {
    // Track whether the user is using keyboard or mouse
    let isUsingKeyboard = false;

    // Define the selectors for all main navigation elements
    const navigationSelectors = [
        // Logo - target the li container instead of the zero-dimension a tag
        '.ad-uniheader__logo-container',
        // Icons - more comprehensive selectors based on actual HTML structure
        '.ad-universalnav-icons .ad-icon-link',
        '.ad-universalnav-icons > .ad-icon-link', // Direct child
        'a.ad-icon-link', // Any anchor with ad-icon-link class
        // Cart (separate selector since it has different structure)
        '.ad-component__cart .ad-icon-link',
        // Dropdown triggers (Company, Manage, User)
        '.ad-component_dropdown .ad-component_dropdown--trigger',
        '.ad-component_dropdown--trigger', // Direct selector
        // Dropdown links inside dropdowns
        '.ad-component_dropdown .ad-component_list .ad-component--link'
    ];

    // Function to add focus outline using JavaScript (with stronger styles)
    const addFocusOutline = (element) => {
        if (!element) return;
        element.style.outline = '2px solid #0066cc !important';
        element.style.outlineOffset = '2px';
        element.style.boxShadow = '0 0 0 2px #0066cc';
    };

    // Function to remove focus outline
    const removeFocusOutline = (element) => {
        if (!element) return;
        element.style.outline = '';
        element.style.outlineOffset = '';
        element.style.boxShadow = '';
        element.style.removeProperty('outline');
    };

    // Function to ensure element is focusable
    const makeFocusable = (element) => {
        if (!element) return;
        
        // Remove browser default outline to prevent double outline
        element.style.outline = 'none';
        
        // Add tabindex if element doesn't already have it
        if (!element.hasAttribute('tabindex')) {
            element.setAttribute('tabindex', '0');
        }
    };

    // Simple search cleanup - just make main search input focusable
    const cleanupSearchTabOrder = () => {
        const mainInput = document.querySelector('.adsearch-universal input[placeholder="Search all products"]') || 
                         document.querySelector('.adsearch-universal input[type="search"]');
        if (mainInput) {
            // Make sure it's focusable
            if (!mainInput.hasAttribute('tabindex')) {
                mainInput.setAttribute('tabindex', '0');
            }
            
            // Remove any existing listener to avoid duplicates
            mainInput.removeEventListener('keydown', handleSearchTab);
            // Add simple Tab key handling to move to next navigation element
            mainInput.addEventListener('keydown', handleSearchTab);
        }
    };
    
    // Separate function for search tab handling to avoid duplicates
    const handleSearchTab = (evt) => {
        if (evt.key === 'Tab' && !evt.shiftKey) {
            evt.preventDefault();
        
            evt.target.blur();
            const navElements = document.querySelectorAll("ad-uniheader__container--section-right li")
            
            // Focus the first one found
            if (navElements.length > 0) {
                navElements[0].focus();
            }
        }
    };

    // Apply focus management to all navigation elements
    const initializeFocusableElements = () => {
        // Initial cleanup of search component tab order
        window.setTimeout(
            () => {
                cleanupSearchTabOrder();
            }, 3000
        );
        
        navigationSelectors.forEach(selector => {
            const elements = document.querySelectorAll(selector);
            elements.forEach((element) => {
                makeFocusable(element);
                
                // Add focus event listener
                element.addEventListener('focus', () => {
                    // Only show outline if user is using keyboard
                    if (isUsingKeyboard) {
                        addFocusOutline(element);
                    }
                });
                
                // Add blur event listener
                element.addEventListener('blur', () => {
                    removeFocusOutline(element);
                });
                
                // Handle keyboard navigation
                element.addEventListener('keydown', (evt) => {
                    if (evt.key === 'Enter' || evt.key === ' ') {
                        const tagName = element.tagName.toLowerCase();
                        const isCartElement = element.closest('.ad-component__cart');
                        const isLogoContainer = element.classList.contains('ad-uniheader__logo-container');
                        
                        // For logo container, find and click the inner link
                        if (isLogoContainer) {
                            evt.preventDefault();
                            const logoLink = element.querySelector('.ad-uniheader__logo-container--link');
                            if (logoLink && logoLink.href) {
                                window.location.href = logoLink.href;
                            } else if (logoLink) {
                                logoLink.click();
                            }
                        }
                        // For cart elements or non-link elements, always trigger click
                        else if (isCartElement || (tagName !== 'a' && tagName !== 'button')) {
                            evt.preventDefault();
                            element.click();
                        }
                        // For regular links with href, let the browser handle navigation
                        else if (tagName === 'a' && element.getAttribute('href')) {
                            // Let the default link behavior happen
                            return;
                        }
                        // For links without href, trigger click
                        else if (tagName === 'a' && !element.getAttribute('href')) {
                            evt.preventDefault();
                            element.click();
                        }
                    }
                });
            });
        });
    };

    // Listen for keyboard usage (Tab key specifically)
    document.addEventListener('keydown', (evt) => {
        if (evt.key === 'Tab') {
            isUsingKeyboard = true;
        }
    });

    // Listen for mouse usage
    document.addEventListener('mousedown', () => {
        isUsingKeyboard = false;
    });

    // Initialize on DOM load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeFocusableElements);
    } else {
        initializeFocusableElements();
    }
} 